export class GoogleAdsProvider {
  static send(
    eventName: string,
    sendTo: string,
    params: Record<string, any> = {}
  ) {
    if (typeof window.gtag !== 'function') {
      console.warn('[Ads] gtag not loaded');
      return;
    }

    if (!sendTo) {
      console.warn(`[Ads] Unknown event: ${eventName}`);
      return;
    }

    window.gtag('event', 'conversion', {
      send_to: sendTo,
      ...params,
    });
  }
}
